const partnersWithTelecom = ['as', 'fr'];

export const isPartnerWithTelecom = (partner: string) => partnersWithTelecom.includes(partner);
